const formatFileSize = size => {
  const units = ['Byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  const threshold = 1024
  size = Number(size) * threshold
  const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(threshold))
  return `${(size / Math.pow(threshold, i)).toFixed(2) * 1} ${units[i]}`
}

export default {
  _default: field => `${field} n'est pas valide.`,
  after: (field, [target]) => `${field} doit être postérieur à ${target}.`,
  alpha: field => `${field} ne peut contenir que des lettres.`,
  alpha_dash: field => `${field} ne peut contenir que des caractères alpha-numériques, tirets ou soulignés.`,
  alpha_num: field => `${field} ne peut contenir que des caractères alpha-numériques.`,
  alpha_spaces: field => `${field} ne peut contenir que des lettres ou des espaces.`,
  before: (field, [target]) => `${field} doit être antérieur à ${target}.`,
  between: (field, [min, max]) => `${field} doit être compris entre ${min} et ${max}.`,
  confirmed: (field, [confirmedField]) => `${field} ne correspond pas à ${confirmedField}.`,
  credit_card: field => `${field} est invalide.`,
  date_between: (field, [min, max]) => `${field} doit être situé entre ${min} et ${max}.`,
  date_format: (field, [format]) => `${field} doit être au format ${format}.`,
  decimal: (field, [decimals = '*'] = []) => `${field} doit être un nombre et peut contenir ${decimals === '*' ? 'des' : decimals} décimales.`,
  digits: (field, [length]) => `${field} doit être un nombre entier de ${length} chiffres.`,
  dimensions: (field, [width, height]) => `${field} doit avoir une taille de ${width} pixels par ${height} pixels.`,
  email: field => `${field} doit être une adresse e-mail valide.`,
  excluded: field => `${field} doit être une valeur valide.`,
  ext: field => `${field} doit être un fichier valide.`,
  image: field => `${field} doit être une image.`,
  included: field => `${field} doit être une valeur valide.`,
  integer: field => `${field} doit être un entier.`,
  ip: field => `${field} doit être une adresse IP.`,
  length: (field, [length, max]) => {
    if (max) {
      return `${field} doit contenir entre ${length} et ${max} caractères.`
    }

    return `${field} doit contenir ${length} caractères.`
  },
  max: (field, [length]) => `${field} ne peut pas contenir plus de ${length} caractères.`,
  max_value: (field, [max]) => `${field} doit avoir une valeur de ${max} ou moins.`,
  mimes: field => `${field} doit avoir un type MIME valide.`,
  min: (field, [length]) => `${field} doit contenir au minimum ${length} caractères.`,
  min_value: (field, [min]) => `${field} doit avoir une valeur de ${min} ou plus.`,
  numeric: field => `${field} ne peut contenir que des chiffres.`,
  regex: field => `${field} est invalide.`,
  required: field => `${field} est obligatoire.`,
  size: (field, [size]) => `${field} doit avoir un poids inférieur à ${formatFileSize(size)}.`,
  url: field => `${field} n'est pas une URL valide.`
}
